import type React from 'react';
import { useCallback } from 'react';

import { ACTION_TYPE_SET_CARRIER_SERVICE_PACKAGE } from '../../../../settings/automation-rules/constants/action-types';

import { PlaybookCard } from '../../playbook-card/playbook-card';

import type { PreconfiguredRule } from '../automation-playbook-types';
import { AutomationPlaybooks } from '../playbooks';
import { useOpenRuleEditor } from '../use-open-rule-editor';
import { messages } from '../messages';

export const ORDER_TAG_SHIPPING_RULE: PreconfiguredRule = {
  active: true,
  isNew: true,
  isTemplate: true,
  playbook: AutomationPlaybooks.ShippingServiceByOrderTag,
  ruleName: messages.orderTagShippingRuleName,
  filterConditions: [{ fieldType: 'OrderTags', operator: 'includes', value: '', logicalOperator: 'AND' }],
  orderRuleActions: [
    {
      actionTypeId: ACTION_TYPE_SET_CARRIER_SERVICE_PACKAGE,
      parameter: undefined,
      isDeleted: false,
    },
  ],
};

export const OrderTagRuleCard: React.FC = () => {
  const openRuleEditor = useOpenRuleEditor();
  const handleClick = useCallback(() => openRuleEditor(ORDER_TAG_SHIPPING_RULE), [openRuleEditor]);

  return (
    <PlaybookCard
      description={messages.orderTagShippingDescription}
      glyph='tag'
      onClick={handleClick}
      title={messages.orderTagShippingTitle}
    />
  );
};
